$shm_mentionstat_filter_panel $shm_service_filter_panel
	date_from? \
	date_to? \
	query_values /
	query_rows /
	query_all? false
	query_checked*? false
	query_only*? null
	total_visible? true
	scope_values /
	scope_rows /
	scope_all? false
	scope_checked*? false
	scope_only*? null
	country_values /
	country_rows /
	country_all? false
	country_checked*? false
	country_only*? null
	language_values /
	language_rows /
	language_all? false
	language_checked*? false
	language_only*? null
	type_values /
	type_rows /
	type_all? false
	type_checked*? false
	type_only*? null
	category_values /
	category_rows /
	category_all? false
	category_checked*? false
	category_only*? null
	reset? null
	body /
		<= Filters $mol_list
			rows /
				<= Period_section $shm_wordstat_filter_section
					title \Период
					Expand null
					content /
						<= Period $shm_period
							date_from? <=> date_from? \
							date_to? <=> date_to? \
				<= Scope_section $shm_wordstat_filter_section
					title_content /
						<= Scope_title $mol_view sub / \Источники
						<= Scope_all $mol_check_box
							title \Все
							Icon <= Scope_all_icon $mol_icon_check_all
							checked? <=> scope_all? false
					Expand null
					content /
						<= Scope_list $mol_view
							sub <= scope_rows
				<= Query_section $shm_wordstat_filter_section
					title_content /
						<= Query_title $mol_view sub / \Запросы
						<= Query_all $mol_check_box
							title \Все
							Icon <= Query_all_icon $mol_icon_check_all
							checked? <=> query_all? false
					Expand null
					content /
						<= Total $mol_check_box
							title \Итого
							checked? <=> total_visible? true
						<= Query_list $mol_view sub <= query_rows
				<= Country_section $shm_wordstat_filter_section
					title_content /
						<= Country_title $mol_view sub / \Страны
						<= Country_all $mol_check_box
							title \Все
							Icon <= Country_all_icon $mol_icon_check_all
							checked? <=> country_all? false
					Expand null
					content /
						<= Country_list $mol_view
							sub <= country_rows
				<= Language_section $shm_wordstat_filter_section
					title_content /
						<= Language_title $mol_view sub / \Языки
						<= Language_all $mol_check_box
							title \Все
							Icon <= Language_all_icon $mol_icon_check_all
							checked? <=> language_all? false
					Expand null
					content /
						<= Language_list $mol_view
							sub <= language_rows
				<= Type_section $shm_wordstat_filter_section
					title_content /
						<= Type_title $mol_view sub / \Типы
						<= Type_all $mol_check_box
							title \Все
							Icon <= Type_all_icon $mol_icon_check_all
							checked? <=> type_all? false
					Expand null
					content /
						<= Type_list $mol_view
							sub <= type_rows
				<= Category_section $shm_wordstat_filter_section
					title_content /
						<= Category_title $mol_view sub / \Категории
						<= Category_all $mol_check_box
							title \Все
							Icon <= Category_all_icon $mol_icon_check_all
							checked? <=> category_all? false
					Expand null
					content /
						<= Category_list $mol_view
							sub <= category_rows
	Query_row* $shm_mentionstat_filter_panel_row
		title <= query_title* \
		checked? <=> query_checked*? false
		only? <=> query_only*? null
	Scope_row* $shm_mentionstat_filter_panel_row
		title <= scope_title* \
		checked? <=> scope_checked*? false
		only? <=> scope_only*? null
	Country_row* $shm_mentionstat_filter_panel_row
		title <= country_title* \
		checked? <=> country_checked*? false
		only? <=> country_only*? null
	Language_row* $shm_mentionstat_filter_panel_row
		title <= language_title* \
		checked? <=> language_checked*? false
		only? <=> language_only*? null
	Type_row* $shm_mentionstat_filter_panel_row
		title <= type_title* \
		checked? <=> type_checked*? false
		only? <=> type_only*? null
	Category_row* $shm_mentionstat_filter_panel_row
		title <= category_title* \
		checked? <=> category_checked*? false
		only? <=> category_only*? null

$shm_mentionstat_filter_panel_row $mol_view
	title \
	checked? false
	only? null
	sub /
		<= Check $mol_check_box
			title <= title \
			checked? <=> checked? false
		<= Only $mol_button_minor
			title \Только
			click? <=> only? null
